<template>
  <section>
    <template v-if="flatten">
      <el-select
        :value="value"
        placeholder="行政區"
        @change="notifyFattenChange"
      >
        <el-option-group
          v-for="group in falttenOptions"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="item in group.distircts"
            :key="item.zip"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-option-group>
      </el-select>
    </template>
    <template v-else>
      <el-select
        v-model="currentCity"
        placeholder="縣市"
        @change="notifyChange"
      >
        <el-option
          v-for="item in availableCities"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select v-model="value" placeholder="行政區" @change="notifyChange">
        <el-option
          v-for="item in options"
          :key="item.zip"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </template>
  </section>
</template>

<script>
import districtData from './data/twDistricts'
const cities = Object.keys(districtData)
const _map = (obj, callback) => {
  return Object.keys(obj).map((key) => {
    return callback(key, obj[key])
  })
}

const toDistrictFormat = (districtName, zipCode) => ({
  label: districtName,
  value: districtName,
  zip: zipCode,
})

const mixin = {
  props: {
    /* Feature for Long-term care */
    flatten: {
      type: Boolean,
      default: false,
    },
    cities: {
      type: [Array, String],
      default: () => [],
    },
  },
  computed: {
    falttenOptions() {
      if (typeof this.cities === 'string') {
        return {
          label: this.cities,
          districts: _map(districtData[this.cities], toDistrictFormat),
        }
      }

      if (this.cities.length > 0) {
        return this.cities.reduce((_opts, _cityName) => {
          return _opts.concat({
            label: _cityName,
            distircts: _map(districtData[_cityName], toDistrictFormat),
          })
        }, [])
      }
    },
  },
  methods: {
    notifyFattenChange($event) {
      this.$emit('input', {
        districtName: $event,
      })
    },
  },
}
export default {
  mixins: [mixin],
  props: ['value'],
  data() {
    return {
      availableCities: cities.map((city) => ({ label: city, value: city })),

      currentCity: null,
      // currentDistrict: null,
    }
  },
  computed: {
    options() {
      if (!this.currentCity || !districtData[this.currentCity]) return []
      return _map(districtData[this.currentCity], toDistrictFormat)
    },
  },
  methods: {
    notifyChange($event) {
      this.$emit('input', {
        cityName: this.currentCity,
        districtName: $event,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/select/DistrictSelector.vue